import React from 'react';
import { withStyles,
  FormControl,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle} from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import LimiteCobrancaService from '../../../services/LimiteCobrancaService';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  formControl: {
    margin: theme.spacing.unit * 2,
    minWidth: 280,
  },
  flex: {
    display: 'flex',
  },
  textFieldObservacao: {
    marginTop: theme.spacing.unit * 2,
    width: 280,
  },
});
@inject('usuarioStore')
@observer
class FormDialogLimiteCobranca extends React.Component {
  limiteCobrancaService = new LimiteCobrancaService();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.limite,
      errorMessageValorPercentual: '',
      errorMessageDataInicio: '',
      errorMessageDataFim: '',
    };
  }
  handleClickSave = async () => {
    const limite = {
      codVigencia: this.state.codVigencia === undefined ? 0 : this.state.codVigencia,
      valPercentual: Number(this.state.valPercentual),
      dtaInicio: this.state.dtaInicio,
      dtaFim: this.state.dtaFim,
      txtObservacao: this.state.txtObservacao === null || this.state.txtObservacao === undefined ? '' : this.state.txtObservacao,
      isFolhaFechada: this.props.isFolhaFechada,
    };
    await this.props.handleSave(limite);
  }
  handleChangeTextField = event => {
    var valorNovo = '';
    if (event.target.name === 'valPercentual') {
      valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 2);
      this.setState({ [event.target.name]: valorNovo, errorMessageValorPercentual: '' });
    }
    if (event.target.name === 'dtaInicio') {
      this.setState({ [event.target.name]: event.target.value, errorMessageDataInicio: '' });
    }
    if (event.target.name === 'dtaFim') {
      this.setState({ [event.target.name]: event.target.value, errorMessageDataFim: '' });
    }
    if (event.target.name === 'txtObservacao') {
      this.setState({ [event.target.name]: event.target.value });
    }
  };
  handleBlurDataInicio = () => {
    if (this.state.dtaInicio === null ||
        this.state.dtaInicio === undefined ||
        this.state.dtaInicio === '') {
      this.setState({errorMessageDataInicio: 'Favor preencher a data início'});
    } else {
      this.setState({errorMessageDataInicio: ''});
    }
  }
  handleBlurValorPercentual = event => {
    if (this.state.valPercentual === '' || this.state.valPercentual === null || this.state.valPercentual === undefined) {
      this.setState({errorMessageValorPercentual: 'Favor preencher o percentual'});
    } else {
      this.setState({errorMessageValorPercentual: ''});
    }
  }
  isSalvarDisabled = () => {
    return (this.state.errorMessageValorPercentual !== '' ||
    this.state.valPercentual === undefined ||
    this.state.valPercentual === '' ||
    this.state.valPercentual === 0 ||
    this.state.valPercentual === '0' ||
    this.state.valPercentual === '00') ||

    (this.state.errorMessageDataInicio !== '' ||
    this.state.dtaInicio === undefined ||
    this.state.dtaInicio === '' ||
    this.state.dtaInicio === null);
  }
  handleClickEditar = event => {
    event.target.select();
  }
  render () {
    const { classes, open, handleClose, titulo, modoInclusao } = this.props;
    const proximoLimite = this.props.ultimoLimite + 1;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='xs'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>{titulo}</DialogTitle>
          <DialogContent>
            <FormControl className={classes.formControl}>
              <TextField
                value={this.state.valPercentual === undefined ? '0' : this.state.valPercentual}
                margin='dense'
                id='valPercentual'
                name='valPercentual'
                error={this.state.errorMessageValorPercentual !== ''}
                label={this.state.errorMessageValorPercentual !== '' ? this.state.errorMessageValorPercentual : 'Percentual %'}
                fullWidth
                onChange={this.handleChangeTextField}
                onBlur={this.handleBlurValorPercentual}
                onFocus={this.handleClickEditar}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                id='dtaInicio'
                error={this.state.errorMessageDataInicio !== ''}
                label={this.state.errorMessageDataInicio !== '' ? this.state.errorMessageDataInicio : 'Data Início'}
                type='date'
                value={this.state.dtaInicio === '1969-12-31' ? '' : this.state.dtaInicio}
                onChange={this.handleChangeTextField}
                inputProps={{
                  name: 'dtaInicio',
                }}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                onBlur={this.handleBlurDataInicio}
                onFocus={this.handleClickEditar}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                id='dtaFim'
                label='Data Fim'
                type='date'
                value={this.state.dtaFim === '1969-12-31' ? '' : this.state.dtaFim}
                onChange={this.handleChangeTextField}
                inputProps={{
                  name: 'dtaFim',
                }}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                onFocus={this.handleClickEditar}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                id='txtObservacao'
                name='txtObservacao'
                className={classes.textFieldObservacao}
                value={(this.state.txtObservacao !== undefined && this.state.txtObservacao !== 0) ? this.state.txtObservacao : ''}
                margin='dense'
                fullWidth
                onChange={this.handleChangeTextField}
                label={'Observação'}
                multiline
                rowsMax='4'
                style={{maxlength: '200'}}
                helperText='(max. 200 caracteres)'
                InputLabelProps={{
                  shrink: true,
                }}
                onFocus={this.handleClickEditar}
              />
            </FormControl>
            {modoInclusao && <Typography> {'* O limite de sequencial ' + this.props.ultimoLimite + ' será encerrado com a data atual e será criado o novo limite com o sequencial ' + proximoLimite}</Typography>}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled()}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogLimiteCobranca);
